
const $el = $(el);

let player;

$body.on('youtube.ready', function () {
    player = new YT.Player(el.querySelector('iframe'));
});

$el.on('click', function (e) {
    console.log(player);
    if (player) player.playVideo();
});